import { CheckPermissionsHandler } from '../../checkPermissions/CheckPermissions';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const checkPermissionsHandler: CheckPermissionsHandler = () => {};
